import CreditCardForm from 'components/GlobalModals/PaidReservationModal/PaymentSection/PaymentSectionContent/PaymentInfo/CreditCardForm/CreditCardForm';

export default CreditCardForm;
